export class StubFile extends File {
	constructor( fileName = 'stub-file' ) {
		super( [], fileName );
	}
}
